<template>
  <el-dialog title="退款确认" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
    <div class="modal-body">
      <el-form label-width="120px" :model="formData" :rules="rules" ref="refundForm">
        <el-form-item label="退款人：">
          <span>{{ formData.username }}</span>
        </el-form-item>
        <el-form-item label="商品名称">
          <span>{{ formData.prodname }}</span>
        </el-form-item>
        <el-form-item label="退款原因：" prop="returnReason">
          <el-input type="textarea" :rows="2" v-model="formData.returnReason" placeholder="必填，请填写退款原因">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
      <el-button type="primary" @click="_refoundOrderCart">确定退款</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { submitReturn } from '@/api/platform/personalCenter/orderApi'

export default {
  name: 'SendStoreOrderCart',
  data() {
    return {
      dialogVisible: false,
      formData: {
        username: '',
        prodname: '',
        shopId: "",
        returnReason: "",
        personId: "",
        orderId: "",
        cartId: ""
      },
      rules: {
        returnReason: [
          { required: true, message: '请填写退款原因', trigger: 'blur' }
        ]
      },
      sendStoreOrderCartInfo: {
        orderId: '',
        username: '',
        tel: '',
        address: '',
        solCompany: '',
        solNum: '',
        remark: '',
        sendWay: 'SEFT',
        solCompanys: [],
        shopId: ''
      }
    }
  },
  methods: {
    open(order) {
      console.log(order)
      console.log(order.storeOrderCartDtos[0].prodName)
      this.formData.username = order.personName
      this.formData.prodname = order.storeOrderCartDtos[0].prodName
      this.formData.shopId = order.shopId
      this.formData.personId = order.personId
      this.formData.orderId = order.orderId
      this.formData.cartId = order.storeOrderCartDtos[0].cartId
      this.formData.returnReason = ""

      this.dialogVisible = true
      
      // 等待 DOM 更新后清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.refundForm) {
          this.$refs.refundForm.clearValidate()
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.clearFormData()
    },
    clearFormData() {
      this.formData.username = ''
      this.formData.prodname = ''
      this.formData.shopId = ''
      this.formData.returnReason = ''
      this.formData.personId = ''
      this.formData.orderId = ''
      this.formData.cartId = ''
      
      if (this.$refs.refundForm) {
        this.$refs.refundForm.resetFields()
      }
    },
    async _refoundOrderCart() {
      try {
        // 先进行表单验证
        const valid = await this.$refs.refundForm.validate()
        
        if (!valid) {
          return false
        }
        
        let data = {
          shopId: this.formData.shopId,
          personId: this.formData.personId,
          orderId: this.formData.orderId,
          cartId: this.formData.cartId,
          returnReason: this.formData.returnReason
        }
        console.log('提交数据:', data)
        
        const res = await submitReturn(data)
        console.log('返回结果:', res)
        if (res.code === 0) {
          this.$message.success('退货/退款申请成功')
          this.handleClose()
          this.$emit('success')
        } else {
          this.$message.error(res.msg || '退款申请失败')
        }
      } catch (error) {
        // 表单验证失败或请求失败都会进入这里
        if (error !== false) {
          console.error('请求失败处理', error)
          this.$message.error('退款申请失败，请稍后重试')
        }
      }
    }
  }
}
</script>

<style scoped>
.modal-body {
  padding: 20px;
}
</style>
